import { VolunteerContextProvider } from 'context/volunteer.context'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import VolunteerRegistrationList from './VolunteerRegistrationList'

export default function StaticModeRegistrationPage() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const volunteerToken = searchParams.get('volunteerToken')?.trim()

  if (!volunteerToken) {
    return (
      <div className="card bg-white border-round-xl p-4 m-3 md:m-4">
        <p className="m-0 text-color-secondary line-height-3">
          {t('Volunteer link is not available for this event.')}
        </p>
      </div>
    )
  }

  return (
    <VolunteerContextProvider>
      <VolunteerRegistrationList />
    </VolunteerContextProvider>
  )
}
